export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const MARK_AS_READ = 'MARK_AS_READ';
export const SET_UNREAD_COUNT = 'SET_UNREAD_COUNT';
